var _rect, _rect2, _path, _path2, _path3, _path4, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCatalogActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4070,
    y: -12477,
    width: 11584,
    height: 15424,
    fill: "#5D5CF5",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-24 -665H232V235H-24V-665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-24 -665H232V235H-24V-665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-24 -14H232V16V46H-24V-14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-18 -8C-18 -12.4183 -14.4183 -16 -10 -16H213C217.418 -16 221 -12.4183 221 -8V8.37548C221 9.7677 221.363 11.1358 222.054 12.3446L224.716 17.0039C224.892 17.3113 224.892 17.6887 224.716 17.9961L222.054 22.6554C221.363 23.8642 221 25.2323 221 26.6245V40C221 44.4183 217.418 48 213 48H-10C-14.4183 48 -18 44.4183 -18 40V-8Z",
    fill: "#5D5CF5",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5D5CF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipCatalogActive)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7676 19.247L26.1806 14.1042L22.8045 10.5505L20.7676 19.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9176 13.7644L19.0203 14.085L20.3686 18.2943L22.0222 11.233L22.1482 10.6953L22.2676 10.1866L22.248 10.182L17.4514 9.05859L17.4336 9.13348L18.8148 13.444L18.9176 13.7644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9838 9.71964L16.8042 9.15858L16.7533 9L12.043 10.509L12.2157 11.0479L15.5749 14.4071L15.8272 14.6597L16.0794 14.9118L16.6587 15.4911L16.8733 15.7055L17.0876 15.9201L19.8443 18.6763L19.8488 18.6619L18.5306 14.5488L18.4281 14.2281L18.3257 13.9076L17.164 10.2814L16.9838 9.71964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4973 10.7585L11.4889 10.767L8 14.2558L14.1664 20.4223L14.4186 20.6744L14.6708 20.9266L14.7781 21.0341L14.8554 21.1114L15.1779 21.434L15.2464 21.5024L15.5001 21.7561L15.7151 21.971L15.9558 22.2117L16.1804 22.4364L16.4051 22.6607L16.7439 23L17.8271 21.9166L17.8514 21.8925L17.899 21.8449L18.1382 21.6057L18.2596 21.4843L18.4251 21.3186L18.5443 21.1993L18.6201 21.1234L19.2625 20.4814L19.2954 20.4482L19.755 19.9885L20.0369 19.7069L20.2151 19.5287L20.2415 19.5021L20.2275 19.4885L20.1145 19.3754L19.9851 19.2457L19.7426 19.0036L16.868 16.1286L16.6537 15.9145L16.4394 15.7001L15.9986 15.2594L15.7464 15.0072L15.4942 14.755L12.4176 11.6787L11.9493 11.2104L11.4973 10.7585ZM17.1346 19.0452C17.6325 19.0452 18.0363 19.4489 18.0363 19.9468C18.0363 20.445 17.6325 20.8485 17.1346 20.8485C16.6366 20.8485 16.2328 20.4447 16.2328 19.9468C16.2328 19.4489 16.6365 19.0452 17.1346 19.0452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipCatalogActive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCatalogActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/catalog-active.97a609f3.svg";
export { ForwardRef as ReactComponent };